
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/tool-shed",
      function () {
        return require("private-next-pages/[locale]/tool-shed/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/tool-shed"])
      });
    }
  